import React, { lazy } from "react";
import queryString from 'query-string';
import { Route } from "react-router-dom";
import { AuthLayout } from "../../modules/theme";
import SocialLogin from "./components/SocialLogin";
// import {
//   ForgotPassword,
//   SignIn,
//   TenantSignIn,
// } from './components';
const ForgotPassword = lazy(() =>
  import(/* webpackChunkName: "forgotpassword" */ "./components/ForgotPassword")
);
const SignIn = lazy(() =>
  import(/* webpackChunkName: "SignIn" */ "./components/SignIn")
);
const TenantSignIn = lazy(() =>
  import(/* webpackChunkName: "TenantSignIn" */ "./components/Tenant-Signin")
);

const socialLogin = ({ location, match }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams, match)
  return  <SocialLogin type={match.params.type}  />;
};

const routes = () => [
  <Route
    exact={true}
    path="/admin"
    key="admin"
    component={() => {
      return (
        <AuthLayout content={<SignIn />} type="admin" background="admin" />
      );
    }}
  />,
  <Route
    path="/sign-in"
    key="signIn"
    component={() => {
      return (
        <AuthLayout
          content={<TenantSignIn />}
          type="TenantSignIn"
          background="TenantSignIn"
        />
      );
    }}
  />,
  <Route
    key="/social-login/:type"
    exact={true}
    path="/social-login/:type"
    component={socialLogin}
  />,
  <Route
    exact={true}
    path="/forgot-password"
    key="forgotPassword"
    component={() => {
      return <AuthLayout content={<ForgotPassword />} />;
    }}
  />,
  <Route
    exact={true}
    path="/admin/forgot-password"
    key="adminForgotPassword"
    component={() => {
      return <AuthLayout content={<ForgotPassword admin={true} />} />;
    }}
  />,
];

export default routes;



// WEBPACK FOOTER //
// src/modules/auth/routes.js